import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AppProvider, Page, Card, ResourceList, ResourceItem, Avatar, TextStyle, Badge, Stack } from '@shopify/polaris';

const propTypes = {
  items: PropTypes.array.isRequired,
  pendingWork: PropTypes.object, // { courier_id: { orders, tasks } }, shown next to each courier when given
}

const CouriersList = (props) => {
  return (
    <ResourceList
      resourceName={{ singular: I18n.t("activerecord.courier.one"), plural: I18n.t("activerecord.courier.other") }}
      items={ props.items }
      renderItem={(item) => {
        const { id, uid, user, editURL, active } = item;
        const pending = props.pendingWork?.[id];
        const pendingCount = pending ? pending.orders + pending.tasks : 0;
        const media = <Avatar customer size="medium" name={user.name} />;

        return (
          <ResourceItem
            id={id}
            url={editURL}
            external
            media={media}
            accessibilityLabel={`View details for ${'user'}`}
            onClick={ () => props.onClick(item) }
          >
            <Stack alignment="center">
              <h3>
                <TextStyle variation="strong">{user.name}</TextStyle>
              </h3>
              { !active && <Badge>{ I18n.t("courier.inactive") }</Badge> }
              {/* Pending work on an inactive courier is abandoned: nobody can finish it */}
              { pendingCount > 0 &&
                <Badge status={ active ? "info" : "critical" }>
                  { I18n.t("courier.pending_work.count", { count: pendingCount }) }
                </Badge>
              }
            </Stack>
          </ResourceItem>
        );
      }}
    />
  );
}


CouriersList.propTypes = propTypes;

export default CouriersList;
